export const MULTISELECT_ERRORS = {
    HYDRATION: {
        VALUE_NOT_AVAILABLE_IN_PAYLOAD:
            "Could not locate values in hydration payload",
        PAYLOAD_VALUE_FAILED_PARSE:
            "Could not parse multi select - values from payload",
        VALUE_NOT_IN_DROPDOWN_ITEM_MAPPER:
            "valueFormat deprecated, content owner must update to use new value configuration for hydration",
        NO_MATCHING_ITEMS_FOUND:
            "no items could be find matching the provided payload",
        SOME_ITEMS_NOT_FOUND: "not all items could be found",
        TOO_MANY_ITEMS_SELECTED:
            "Too many items to selected to repopulate, currently unsupported",
    },
    CONFIGURATION: {
        MISSING_VALUE_IN_DROPDOWN_ITEM_MAPPER:
            "Either dropdownItemMapper.value or dropdownItemMapper.valueFormat must be defined",
        BOTH_VALUE_AND_VALUEFORMAT:
            "Both dropdownItemMapper.value and dropdownItemMapper.valueFormat cannot be defined at the same time",
    },
    RUNTIME: {
        ITEM_VALUE_CANNOT_BE_FOUND: (key: string, value: object): string =>
            `Could not find ${key} in ${JSON.stringify(value)}`,
    },
};

export const LIST_BUILDER_ERRORS = {
    HYDRATION: {
        VALUE_NOT_AVAILABLE_IN_PAYLOAD:
            "Could not locate values in hydration payload",
        PAYLOAD_VALUE_FAILED_PARSE:
            "Could not parse list builder - values from payload",
        VALUE_NOT_IN_DROPDOWN_ITEM_MAPPER:
            "needs value from dropdownItemMapper to rehydrate correctly",
        NO_MATCHING_ITEMS_FOUND:
            "no items could be find matching the provided payload",
        SOME_ITEMS_NOT_FOUND: "not all items could be found",
    },
    CONFIGURATION: {
        MISSING_VALUE_IN_DROPDOWN_ITEM_MAPPER:
            "Either dropdownItemMapper.value or dropdownItemMapper.valueFormat must be defined",
        BOTH_VALUE_AND_VALUEFORMAT:
            "Both dropdownItemMapper.value and dropdownItemMapper.valueFormat cannot be defined at the same time",
    },
    RUNTIME: {
        ITEM_VALUE_CANNOT_BE_FOUND: (key: string, value: object): string =>
            `Could not find ${key} in ${JSON.stringify(value)}`,
    },
};
